import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DescriptionComponent } from './description.component';

@NgModule({
  declarations: [DescriptionComponent],
  exports: [DescriptionComponent],
  imports: [CommonModule],
})
export class DescriptionModule {}
